import { __awaiter, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { ModalDialog } from '../modal_dialog';
const Dialog = createContext({
    open: () => {
        throw new Error('Please render <DialogProvider> above in your tree, to use open()');
    },
});
export const useDialog = () => {
    return useContext(Dialog);
};
export const DialogProvider = ({ layout = ModalDialog, container = document.body, children, }) => {
    const [portal, setPortal] = useState(null);
    const createOpener = useCallback((Component) => (_a) => {
        var { actionButtons, willCloseOnOutsideClickAndEscapeKeyPress = true } = _a, props = __rest(_a, ["actionButtons", "willCloseOnOutsideClickAndEscapeKeyPress"]);
        return new Promise((resolve) => {
            const onResolve = (answer) => {
                setPortal(null);
                resolve(answer);
            };
            const handleOnClose = () => {
                if (willCloseOnOutsideClickAndEscapeKeyPress) {
                    onResolve(false);
                }
            };
            const onActionButtonClick = (actionButton, index) => __awaiter(void 0, void 0, void 0, function* () {
                const succeeded = actionButton.onClick ? yield actionButton.onClick() : true;
                if (succeeded !== false) {
                    onResolve(index === 0);
                }
                return succeeded; // pass it to ModalDialog
            });
            const portal = createPortal(_jsx(Component, Object.assign({ actionButtons: actionButtons.map((actionButton, idx) => (Object.assign(Object.assign({}, actionButton), { onClick: () => onActionButtonClick(actionButton, idx) }))) }, props, { isOpen: true, willCloseOnOutsideClickAndEscapeKeyPress: willCloseOnOutsideClickAndEscapeKeyPress, closeDialog: handleOnClose })), container);
            setPortal(portal);
        });
    }, [container]);
    const memoValue = useMemo(() => {
        return { open: createOpener(layout) };
    }, [createOpener, layout]);
    return (_jsxs(Dialog.Provider, { value: memoValue, children: [children, portal] }));
};
//# sourceMappingURL=use_dialog.js.map